import React from 'react';
import './campaignConsole.css';

// Shared header shell for every wizard step (and the campaign list) —
// eyebrow + title + optional subtitle on the left, optional actions/meta
// on the right. Purely presentational: it owns no state and calls
// nothing, so dropping it into a screen changes what that screen's
// header looks like, never what it does.
const StepHeader = ({ eyebrow, title, subtitle, right }) => {
    return (
        <div className="ccStepHeader">
            <div className="ccStepHeaderLeft">
                {eyebrow && <div className="ccStepEyebrow">{eyebrow}</div>}
                <h2 className="ccStepTitle">{title}</h2>
                {subtitle && <p className="ccStepSubtitle">{subtitle}</p>}
            </div>
            {right && <div className="ccStepHeaderRight">{right}</div>}
        </div>
    );
};

export default StepHeader;
